export default {
	our_specialists(state) {
		return state.our_specialists
	},
	selected_specialist(state) {
		return state.selected_specialist
	},
}
